// ─── 응답 상태 배지 ───────────────────────────────────────────────────────────
import React from 'react';
import { STATUS_META } from '../../constants/adminConstants';

export default function StatusBadge({ status }) {
  const s = String(status || '').toLowerCase();
  const m = STATUS_META[s] || {
    label: (status || '?').toUpperCase(),
    dot:   'bg-slate-400',
    pill:  'bg-slate-100 text-slate-700',
  };
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-lg text-xs font-bold tracking-wide ${m.pill}`}
      style={{ padding: '4px 10px' }}
    >
      <span
        className={`shrink-0 rounded-full ${m.dot}`}
        style={{ display: 'inline-block', width: '8px', height: '8px' }}
      />
      {m.label}
    </span>
  );
}
